
document.addEventListener("DOMContentLoaded", function () {

    /*=============================================>>>>>
    = Cookies =
    ===============================================>>>>>*/
    let cookies = document.querySelector(".cookies");
    if (cookies != null) {
        cookies.addEventListener("click", function (e) {
            e.preventDefault();
            if (tarteaucitron) {
                tarteaucitron.userInterface.openPanel();
            }
        });
    }



    /*=============================================>>>>>
    = Topbut =
    ===============================================>>>>>*/
    let btn = document.querySelector("#topbut");
    if (btn != null) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 300) {
                btn.classList.add("visible");
            } else {
                btn.classList.remove("visible");
            }
        });
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("html").scrollTop = 0;
            document.querySelector("body").scrollTop = 0;
        });
    }

    /*=============================================>>>>>
    = Menu Espace de connexion =
    ===============================================>>>>>*/
    function toggleMenu() {
        var menu = document.querySelector('.user-container nav');
        menu.classList.toggle('show-menu');
    }

    // Écouteur d'événement pour le clic sur l'image de fond
    var backgroundImage = document.getElementById('userConnect');
    backgroundImage.addEventListener('click', toggleMenu);




    /*=============================================>>>>>
    = Slider Clients =
    ===============================================>>>>>*/
    const sliderPartenaires = document.querySelector('#partenaires');
    if (sliderPartenaires) {
        const flktysliderPartenaires = new Flickity(sliderPartenaires, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "center",
            "prevNextButtons": false,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false
        });
    }
    if ( matchMedia('screen and (min-width: 1200px)').matches ) {
        let elementsPartenaires = document.querySelectorAll('.partenaires-slider.no-slider');
        for (let i = 0; i < elementsPartenaires.length; i++) {
            let flktyPartenaires = Flickity.data(elementsPartenaires[i]);
            flktyPartenaires.destroy();
        }
    }



    /*=============================================>>>>>
    = Chiffres animés =
    ===============================================>>>>>*/
    window.addEventListener("scroll", chiffresScroll);
    let viewed = false;
    function isScrolledIntoView(elem) {
        if (elem != null) {
            let docViewTop = window.scrollY || document.documentElement.scrollTop;
            let docViewBottom = docViewTop + window.innerHeight;

            let elemTop = elem.offsetTop;
            let elemBottom = elemTop + elem.offsetHeight;

            return elemBottom <= docViewBottom && elemTop >= docViewTop;
        }
    }
    function chiffresScroll() {
        let colChiffres = document.querySelector(".bloc-chiffres");
        if (isScrolledIntoView(colChiffres) && !viewed) {
            viewed = true;
            let chiffres = document.querySelectorAll(".chiffres");
            chiffres.forEach(function (element) {
                let startCount = 0;
                let endCount = parseInt(element.textContent.replace(" ", ""));
                let duration = 4000;
                let range = endCount - startCount;
                let currentCount = startCount;
                let increment = endCount > startCount ? 1 : -1;
                let stepTime = Math.abs(Math.floor(duration / range));

                let timer = setInterval(function () {
                    currentCount += increment;
                    element.textContent = currentCount.toLocaleString();
                    if (currentCount === endCount) {
                        clearInterval(timer);
                    }
                }, stepTime);
            });
        }
    }


    /*=============================================>>>>>
    = Menu au scroll =
    ===============================================>>>>>*/
    function fixedMenu() {
        let navbar = document.getElementById("main-nav");
        if (window.scrollY >= 135) {
            navbar.classList.add("scrolled");
        } else {
            navbar.classList.remove("scrolled");
        }
    }
    document.addEventListener("scroll", () => {
        fixedMenu();
    });

    // FILTRE ACTUALITES
    var actualites = jQuery('#actus');
    if (actualites) {
        ajaxActus();
    }

    let catListItems = document.querySelectorAll('.cat-list_item');
    if (catListItems != null) {
        catListItems.forEach((item) => {
            item.addEventListener('click', function () {
                catListItems.forEach((item) => item.classList.remove('active'));
                this.classList.add('active');
                ajaxActus(this.getAttribute('data-slug'), this.getAttribute('data-type'));
            });
        });
    }


});


function ajaxActus(slug = "", type="post", page = '1') {
    // Afficher le loader
    let loader = document.querySelector('.loader');
    if (loader != null) {
        loader.classList.add('visible');
    }

    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_actus',
            category: slug,
            type: type,
            page: page,
        },
        success: function (res) {
            if (res) {

                jQuery('#actus').html(res);
                // Cacher le loader
                if (loader != null) {
                    loader.classList.remove('visible');
                }
                let catActive = jQuery('.cat-list_item.active');
                let page = jQuery(".page-numbers").on("click", function (e) {
                    e.preventDefault();
                    ajaxActus(catActive.data("slug"), 'post', jQuery(this).data("page"));
                    window.location.href = "/actualites/#liste";
                });
            }
        }
    });


}




